import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=139ecc87&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=139ecc87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ecc87",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PagePreFooter: require('/vercel/path0/components/page/PreFooter.vue').default,PageFooter: require('/vercel/path0/components/page/Footer.vue').default})
